




















import { Vue, Component, Prop, Model, Emit, Watch } from 'vue-property-decorator';

@Component
export default class DateRangeFilter extends Vue {
    @Model('change', { type: Array, default: () => [] })
    readonly value!: any[];

    @Prop({ type: String, default: '日期' })
    readonly label!: string;

    // 内部值
    internalValue: any[] = [];

    created() {
        this.internalValue = this.value;
    }

    @Watch('value')
    onValueChange(newVal: any[]) {
        this.internalValue = newVal;
    }

    @Emit('change')
    handleChange(value: any[]) {
        // 将日期对象转换为时间戳
        if (value && value.length === 2) {
            const [start, end] = value;
            const timestamps = [start ? new Date(start).getTime() : null, end ? new Date(end).getTime() : null];
            return timestamps;
        }
        return value;
    }
}
